import { render, staticRenderFns } from "./templateCard.vue?vue&type=template&id=8030333e&"
import script from "./templateCard.vue?vue&type=script&lang=js&"
export * from "./templateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports